import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

export default function CollateralTiers() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const tiers = [
    { label: '< $500K market cap', ltv: 40 },
    { label: '$500K – $2M market cap', ltv: 50 },
    { label: '> $2M market cap', ltv: 55 },
  ];

  return (
    <div ref={ref} className="max-w-[700px] mx-auto relative z-10">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
        <h3 className="text-[20px] sm:text-[24px] font-semibold text-white mb-2">Better tokens, better rates.</h3>
        <p className="text-[13px] sm:text-[14px] text-white/40 mb-8 sm:mb-10">Only verified tokens from approved deployers. Market cap determines your agent's LTV.</p>
      </motion.div>

      <div className="space-y-3">
        {tiers.map((tier, i) => (
          <motion.div key={tier.label} initial={{ opacity: 0, y: 20 }} animate={isInView ? { opacity: 1, y: 0 } : {}} transition={{ delay: i * 0.1 }} className="p-4 sm:p-5 rounded-xl" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)' }}>
            <div className="flex justify-between items-center mb-3">
              <span className="text-[12px] sm:text-[13px] text-white/60">{tier.label}</span>
              <span className="text-[14px] sm:text-[16px] font-bold text-white">{tier.ltv}% LTV</span>
            </div>
            <div className="h-1.5 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.04)' }}>
              <motion.div initial={{ width: 0 }} animate={isInView ? { width: `${tier.ltv}%` } : {}} transition={{ delay: i * 0.1 + 0.3, duration: 0.8 }} className="h-full rounded-full" style={{ background: 'linear-gradient(90deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.9) 100%)' }} />
            </div>
          </motion.div>
        ))}
      </div>

      <p className="text-[11px] sm:text-[12px] text-white/30 mt-6 text-center px-4">
        Tokens must be deployed via Clanker, Bankr, Zora, or Flaunch factory contracts. Minimum $5K liquidity. MC:WETH ratio under 50.
      </p>
    </div>
  );
}
